export const RECAPTCHA_SITE_KEY = process.env.GATSBY_PUBLIC_RECAPTCHA_SITE_KEY

function isPreviewHost(hostname) {
  return (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname.endsWith('.netlify.app')
  )
}

/** Skip reCAPTCHA on Netlify preview URLs, localhost, or when explicitly enabled. */
export function shouldSkipRecaptchaClient() {
  if (process.env.GATSBY_PUBLIC_SKIP_RECAPTCHA === 'true') return true
  if (typeof window !== 'undefined' && isPreviewHost(window.location.hostname)) return true
  return false
}

export async function getRecaptchaToken(recaptchaRef, { timeoutMs = 15000 } = {}) {
  if (!RECAPTCHA_SITE_KEY || shouldSkipRecaptchaClient()) {
    return 'dev-bypass'
  }

  if (!recaptchaRef?.current) {
    throw new Error('RECAPTCHA_NOT_READY')
  }

  const token = await Promise.race([
    recaptchaRef.current.executeAsync(),
    new Promise((_, reject) => {
      setTimeout(() => reject(new Error('RECAPTCHA_TIMEOUT')), timeoutMs)
    }),
  ])

  recaptchaRef.current.reset()
  return token
}

export function recaptchaErrorMessage(err) {
  if (err?.message === 'RECAPTCHA_NOT_READY') {
    return 'reCAPTCHA is not ready. Please wait a moment and try again.'
  }
  if (err?.message === 'RECAPTCHA_TIMEOUT') {
    return 'reCAPTCHA timed out. Add this site domain in Google reCAPTCHA admin.'
  }
  return 'Unable to verify reCAPTCHA. Please refresh and try again.'
}
